import React from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

interface SegHeaderLogoProps {
  img: string;
  alt: string;
  width?: string;
  className?: string;
  style?: any;
}

export const SegHeaderLogo = ({
  img,
  alt,
  width = "100%",
  className,
  style
}: SegHeaderLogoProps) => {
  const Img = styled.img`
    width: ${width};
  `;

  return (
    <Link to="/" aria-label="Ir al inicio" style={{ display: "inline-block", cursor: "pointer" }}>
      <Img src={img} alt={alt} width={width} className={className} style={style} />
    </Link>
  );
};